export const TOOLTIP_ANCHOR = 'gmp-custom-tooltip-anchor';
export const TOOLTIP_ID = 'dynamic-tooltip';

// EV Settings Constants
export const MPG_EQUIVALENT_MIN = 50;
export const MPG_EQUIVALENT_MAX = 200;
export const MILES_PER_KWH_MIN = 1;
export const MILES_PER_KWH_MAX = 6;
export const GAS_MPG_MIN = 5;
export const GAS_MPG_MAX = 100;
export const GAS_PRICE_MIN = 1.00;
export const GAS_PRICE_MAX = 10.00;
export const EPA_CONVERSION_FACTOR = 33.705; // 1 gallon of gasoline = 33.705 kWh per the EPA
export const MPGE = 'MPGe';
export const MILES_PER_KWH = 'Miles/kWh';
export const CUSTOM_VEHICLE_OPTION = "Other/Custom";

// Load State Constants
export const LOAD_STATE_ERROR = 'error';
export const LOAD_STATE_LOADING = 'loading';
export const LOAD_STATE_COMPLETE = 'complete';
